import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import { DeltaAtfcmSituationRegulationDto } from 'app/model/CORE';
import React from 'react';
import useWindowDimensions from '../../common/hooks/useWindowDimensions';
import './SlotTable.less';
import { CheckCircleFilled } from '@ant-design/icons';

/* Measure Columns & Measure Table definitions */
export class DeltaRegulationColumn extends ManagedColumn<DeltaAtfcmSituationRegulationDto> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: DeltaAtfcmSituationRegulationDto) => any,
        extra?: ManagedColumnExtra<DeltaAtfcmSituationRegulationDto>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export const DELTA_REGULATION_SELECTED_COLUMN = new DeltaRegulationColumn(
    '',
    '2em',
    object => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

export class StandardDeltaRegulationColumn {
    public static readonly ID = new DeltaRegulationColumn('ID', '10em', object => object.afterSituation.regulId);
    public static readonly IMPACTED_FLIGHTS_BEFORE = new DeltaRegulationColumn(
        'before',
        '4em',
        object => object.beforeImpactedFlightCount,
        { name: 'impactedBefore', columnBand: '# Impacted FLT' },
    );
    public static readonly IMPACTED_FLIGHTS_AFTER = new DeltaRegulationColumn(
        'after',
        '4em',
        object => object.afterSituation.impactedFlightCount,
        { name: 'impactedAfter', columnBand: '# Impacted FLT' },
    );
    public static readonly IMPACTED_FLIGHTS_DELTA = new DeltaRegulationColumn(
        'delta',
        '4em',
        object => object.afterSituation.impactedFlightCount - object.beforeImpactedFlightCount,
        { name: 'impactedDelta', columnBand: '# Impacted FLT' },
    );
    public static readonly DELAY_BEFORE = new DeltaRegulationColumn(
        'before',
        '4em',
        object => object.beforeDelayInMin,
        { name: 'delayBefore', columnBand: 'Delay' },
    );
    public static readonly DELAY_AFTER = new DeltaRegulationColumn(
        'after',
        '4em',
        object => object.afterSituation.delayInMin,
        { name: 'delayAfter', columnBand: 'Delay' },
    );
    public static readonly DELAY_DELTA = new DeltaRegulationColumn(
        'delta',
        '4em',
        object => object.afterSituation.delayInMin - object.beforeDelayInMin,
        { name: 'delayDelta', columnBand: 'Delay' },
    );
}

class DeltaRegulationTableBase extends ManagedTable<DeltaAtfcmSituationRegulationDto> {}

// I have had to adapt ManagedTable so that it accepts a font size.
// VirtualTable that is behind only accepts column width in "px", whereas our column definition is in "em".
// This usually is not a problem when font size is fixed, but in our case, font size depends on the viewport width.
// When the viewport is resized, the new font size is provided to the flight table, that will adapt column width accordingly.
const DeltaRegulationTable = (props: ManagedTableProps<DeltaAtfcmSituationRegulationDto>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <DeltaRegulationTableBase fontSize={fontSize} {...props} />;
};

export default DeltaRegulationTable;
